<script setup lang="ts">
import { ref } from 'vue'

const faqInfo = [
  {
    id: '1',
    name: 'Di mana saya bisa mendapatkan aplikasi Rintisan Billing?',
    desc: 'Kabar gembira untuk Anda! Anda bisa langsung "Pakai Gratis Sekarang" Rintisan Billing. Cukup klik tombol DAFTAR, dan ya! Anda sudah siap memulai perjalanan invoicing yang #MakinRingan. Tidak perlu repot-repot ke mana-mana, cukup dari perangkat seperti Smartphone atau Laptop kesayangan Anda!',
  },
  {
    id: '2',
    name: 'Apa syarat yang dibutuhkan untuk menjadi bagian dari Rintisan Billing?',
    desc: 'Syaratnya sangat Mudah dan Sederhana! Yang Anda butuhkan hanyalah semangat untuk membuat bisnis Anda #MakinRingan. Rintisan Billing terbuka untuk semua kalangan pebisnis, dari yang baru merintis sampai yang sudah berpengalaman. Jadi, siapkan semangat Anda, dan mari bergabung dengan Kami!',
  },
  {
    id: '3',
    name: 'Fitur dan Layanan Rintisan menawarkan 3 layanan utama apa saja?',
    desc: `<ol class="space-y-4 text-base list-decimal pl-7 text-neutral-600">
  <li>
    <span>Smart Payment</span><br />
    Sistem pembayaran yang memudahkan proses penerimaan dan pembayaran dengan berbagai metode seperti Direct CC, Virtual Account, QRIS, dan integrasi dengan Marketplace seperti Blibli.
  </li>
  <li>
    <span>Business Management</span><br />
    Fitur lengkap untuk mengelola bisnis termasuk dashboard analitik, manajemen stok, laporan keuangan dengan
    <a href="https://business.rintisan.co.id" class="underline text-neutral-600" target="_blank">https://business.rintisan.co.id</a>.
  </li>
  <li>
    <span>Digital Invoicing</span><br />
    Platform <a href="https://billing.rintisan.co.id" class="underline text-neutral-600" target="_blank">https://billing.rintisan.co.id</a>
    Pembuatan dan pengiriman invoice digital yang dapat dilakukan dalam hitungan detik. Dilengkapi dengan template professional dan sistem pengingat otomatis melalui WhatsApp atau email.
  </li>
</ol>`,
  },
  {
    id: '4',
    name: 'Apakah Membayar Invoice Rintisan Billing dikenakan Biaya?',
    desc: 'Ya, ada biaya layanan yang dikenakan namun sangat kompetitif. Biaya ini mencakup seluruh fitur keamanan dan kenyamanan dalam bertransaksi. Biaya layanan dapat dibebankan kepada merchant atau customer sesuai kesepakatan. Besaran biaya ini sebanding dengan kemudahan dan efisiensi yang didapatkan dalam proses transaksi bisnis.',
  },
  {
    id: '5',
    name: 'Kapan Invoice Rintisan Billing bisa dibayar?',
    desc: 'Pembayaran dapat dilakukan segera setelah menerima notifikasi invoice melalui WhatsApp atau email. Customer dapat mengklik link pembayaran yang dikirimkan dan akan diarahkan ke halaman pembayaran Rintisan Billing yang menampilkan detail invoice secara lengkap.',
  },
  {
    id: '6',
    name: 'Keuntungan Menggunakan Rintisan Billing?',
    desc: `<div class="space-y-4 text-base leading-relaxed text-neutral-600">
  <p>
    <span>Rintisan Billing</span> menghadirkan berbagai keuntungan yang memudahkan proses transaksi bisnis Anda.
    Platform <a href="https://billing.rintisan.co.id" target="_blank" class="underline text-neutral-600">https://billing.rintisan.co.id</a>
    dapat diakses 24/7 dari mana saja, sehingga Anda tidak perlu khawatir tentang batasan waktu atau lokasi dalam mengelola pembayaran.
    Sistem keamanan yang terenkripsi menjamin setiap transaksi berjalan dengan aman dan terpercaya, ditambah dengan proses pembayaran yang cepat dan efisien.
    Anda bisa memilih berbagai metode pembayaran sesuai kebutuhan, mulai dari Direct CC, Virtual Account, QRIS hingga marketplace seperti Blibli.
  </p>
  <p>
    Yang membuat <span>Rintisan Billing</span> semakin unggul adalah dashboard bisnis yang lengkap dan informatif,
    memungkinkan Anda memantau performa bisnis secara real-time.
    Tidak perlu menunggu lama untuk menerima dana, karena sistem pencairan <span>H+1</span> memastikan cashflow bisnis Anda tetap lancar.
    <span>Rintisan Billing</span> hadir sebagai solusi lengkap untuk kebutuhan pembayaran digital bisnis franchise, waralaba, kemitraan, dan UMKM Anda.
  </p>
</div>`,
  },
  {
    id: '7',
    name: 'Bagaimana cara menghapus akun Rintisan Billing?',
    desc: 'Untuk menghapus akun Rintisan Billing, silakan hubungi tim support kami melalui email di <strong class="text-neutral-700">support@rintisan.co.id</strong>. Permintaan Anda akan diproses sesuai prosedur keamanan yang berlaku.',
  },
  {
    id: '8',
    name: 'Bagaimana cara menghubungi Rintisan Billing jika pertanyaan saya tidak terjawab di sini?',
    desc: `<div class="space-y-4 text-base leading-relaxed text-neutral-600">
  <p>Jangan khawatir, tim support Rintisan Billing siap membantu Anda! Anda bisa langsung menghubungi kami di:</p>
  <p>
    <strong>Email: <a href="mailto:support@rintisan.co.id" class="text-neutral-600">support@rintisan.co.id</a></strong><br />
    <strong>Jam kerja: Senin–Jumat, 09:00–17:00</strong>
  </p>
  <p>Atau jika Anda sedang berada di Jakarta, Anda bisa mengunjungi kantor Kami di Holland Village Office Tower lantai 26. Kami jamin, pertanyaan Anda akan dijawab dengan ramah!</p>
</div>`,
  },
]

const openIds = ref<Set<string>>(new Set())

function toggle(id: string) {
  const next = new Set(openIds.value)
  if (next.has(id)) {
    next.delete(id)
  }
  else {
    next.add(id)
  }
  openIds.value = next
}
</script>

<template>
  <section id="faq" class="container mx-auto pb-[40px] mt-[80px] xs:px-4">
    <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
      <h1 class="text-[42px] xs:text-[32px] font-medium text-neutral-800 font-geist-mono">
        Frequently <br class="xs:hidden">
        asked questions
      </h1>
      <p class="mt-4 text-lg font-normal text-neutral-600 font-geist">
        Kami di sini untuk membantu dengan pertanyaan <br class="xs:hidden">
        apa pun yang Anda miliki tentang paket, harga, <br class="xs:hidden">
        penagihan, pencairan, dan fitur yang didukung.
      </p>
    </AnimateOnce>

    <div class="mt-16 mb-20 xs:mt-[30px] xs:mb-20 space-y-3">
      <div
        v-for="item in faqInfo"
        :key="item.id"
        class="border rounded-md border-neutral-200 xs:px-4 overflow-hidden"
        :class="openIds.has(item.id) ? 'bg-white' : 'bg-white'"
      >
        <button
          type="button"
          class="flex w-full items-center justify-between gap-4 text-left text-base font-semibold text-neutral-600 py-4 px-4 font-geist-mono"
          @click="toggle(item.id)"
        >
          <span class="flex-1">{{ item.name }}</span>
          <span class="relative flex items-center justify-center shrink-0 size-5 ml-2">
            <svg
              class="absolute transition-all duration-200 text-neutral-500"
              :class="openIds.has(item.id) ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'"
              width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <svg
              class="absolute transition-all duration-200 text-neutral-500"
              :class="openIds.has(item.id) ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 rotate-90 scale-0'"
              width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 12h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
          </span>
        </button>
        <!-- Grid rows trick: 0fr → 1fr gives a smooth height transition without fixed max-height -->
        <div
          class="grid transition-all duration-300 ease-in-out"
          :style="{ gridTemplateRows: openIds.has(item.id) ? '1fr' : '0fr' }"
        >
          <div class="overflow-hidden">
            <div class="text-base text-neutral-600 px-4 pb-4" v-html="item.desc" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
